import React from 'react';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { GetEMCSettings, EMCSettingType, CreateDefalutEMCSettingType } from '../../../../function/EMCModel';
import { ItemCheckBox } from '../../../atoms/CheckBox/ItemCheckBox';
import { ComboBoxItemTypeSOD, ItemComboBoxStrOD } from './../../../atoms/ComboBox/ItemComboBoxStrOD';
const useStyles = makeStyles(
  createStyles({
    //テーブルボディーセル
    tableCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      minWidth: '100px',
      padding: 1,
    },
    itemBoxStyle: {
      width: '300px',
    },
    spanStyle: {
      display: 'inline-block',
      width: '300px',
    },
  })
);

type EMCSettingGridRowProps = {
  emcSettingRow: EMCSettingType;
  onChangeEvent: (value: EMCSettingType) => void;
  cmoboBoxItemList: ComboBoxItemTypeSOD[];
};

const EMCSettingGridRow: React.FC<EMCSettingGridRowProps> = (props) => {
  const classes = useStyles();

  const onInputChackBoxChenge = (e: React.ChangeEvent<HTMLInputElement>) => {
    //console.debug(['onInputChackBoxChenge', e]);
    let editData = Object.assign({}, props.emcSettingRow);
    editData.RunFlg = !editData.RunFlg;
    //console.debug(['onInputChackBoxChenge editData.RunFlg', editData.RunFlg]);
    props.onChangeEvent(editData);
  };
  const onInputConboBoxChenge = (event: { name?: string; value: unknown }) => {
    console.debug(['onInputConboBoxChenge name value', event.name, event.value]);
    let editData = Object.assign({}, props.emcSettingRow);
    editData.DEV_INDEX = Number(event.value);
    //console.debug(['onInputChackBoxChenge editData.RunFlg', editData.RunFlg]);
    props.onChangeEvent(editData);
  };

  return (
    <>
      <TableRow key={props.emcSettingRow.indexNo}>
        <TableCell className={classes.tableCell}>{props.emcSettingRow.indexNo}</TableCell>
        <TableCell className={classes.tableCell}>
          <input type="checkbox" value="js" onChange={onInputChackBoxChenge} checked={props.emcSettingRow.RunFlg} />
        </TableCell>
        <TableCell className={classes.tableCell}>{props.emcSettingRow.UnitNo}</TableCell>
        <TableCell className={classes.tableCell}>{props.emcSettingRow.AreaNo}</TableCell>
        <TableCell className={classes.tableCell} width={300}>
          <ItemComboBoxStrOD
            itemList={props.cmoboBoxItemList}
            label=""
            itemBoxStyle={classes.itemBoxStyle}
            spanStyle={classes.spanStyle}
            value={props.emcSettingRow.DEV_INDEX.toString()}
            onChangeEvent={onInputConboBoxChenge}
          ></ItemComboBoxStrOD>
        </TableCell>
      </TableRow>
    </>
  );
};

export default EMCSettingGridRow;
